import * as Sentry from '@sentry/react';
import { ApolloCache } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { API_AKTIVIEREN, API_DEAKTIVIEREN } from '../lib/graphql/mutations';

function schreibeAktivInCache(cache: ApolloCache, neuerWert: boolean) {
  cache.modify({
    fields: {
      aktivierung(existing) {
        return { ...existing, aktiv: neuerWert };
      },
    },
  });
}

export type ApiAktivierung = {
  aktiviere: (vertragsnummer: string) => Promise<boolean>;
  deaktiviere: () => Promise<boolean>;
  loading: boolean;
};

export function useApiAktivierung(): ApiAktivierung {
  const [aktiviereMutation, { loading: aktiviereLaeuft }] = useMutation(
    API_AKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.aktiviereApi.__typename === 'ApiAktivierenSuccess') {
          schreibeAktivInCache(cache, true);
        }
      },
    },
  );

  const [deaktiviereMutation, { loading: deaktiviereLaeuft }] = useMutation(
    API_DEAKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.deaktiviereApi.__typename === 'ApiDeaktivierenSuccess') {
          schreibeAktivInCache(cache, false);
        }
      },
    },
  );

  async function aktiviere(vertragsnummer: string): Promise<boolean> {
    try {
      const { data } = await aktiviereMutation({
        variables: { vertragsnummer },
      });
      return data?.aktiviereApi.__typename === 'ApiAktivierenSuccess';
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }

  async function deaktiviere(): Promise<boolean> {
    try {
      const { data } = await deaktiviereMutation();
      return data?.deaktiviereApi.__typename === 'ApiDeaktivierenSuccess';
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }

  return {
    aktiviere,
    deaktiviere,
    loading: aktiviereLaeuft || deaktiviereLaeuft,
  };
}
